import { Button, useToast } from '@chakra-ui/react';
import { ethers } from 'ethers';
import { useWriteContract, useWaitForTransactionReceipt } from 'wagmi';
import ScrollStatKey from '../../assets/abis/ScrollStatKey.json';
import api from '../../utils/axios';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';

const MintButton = ({ price, isDisabled, variant, colorScheme, text, isCurrent, getMintKeys }) => {
	const toast = useToast();
	const navigate = useNavigate();
	const contractAddress = process.env.REACT_APP_COLLECTION_ADDRESS;
	const [isCheckBackendMintEvent, setIsCheckBackendMintEvent] = useState(false);
	const { refreshUserData } = useUser();
	const { data: hash, writeContract, error: txError, status: transactionStatus, isLoading, isSuccess } = useWriteContract();

	const { isLoading: isConfirming, isSuccess: isConfirmed, data } =
		useWaitForTransactionReceipt({
			hash,
		})


	const handleMint = async () => {
		try {
			await writeContract({
				address: contractAddress,
				abi: ScrollStatKey.abi,
				functionName: 'mint',
				value: ethers.parseEther(price)
			});
			// await refreshUserData()
			// console.log('tx', tx);
			window.gtag('event', 'button_click', {
				event_category: 'Button',
				event_label: 'mint_click',
			});


		} catch (error) {
			toast({
				title: 'Mint failed!',
				description: `Error: ${error.message}`,
				status: 'error',
				duration: 9000,
				isClosable: true
			});
		}
	};

	const iface = new ethers.Interface(ScrollStatKey.abi);

	useEffect(() => {
		if (hash && isConfirmed) {
			try {
				const parsedLog = iface.parseLog(data.logs[0]);
				const tokenId = parsedLog.args.id.toString();

				const checkBackendMintData = async (tokenId) => {
					try {
						const response = await api.get(`/user/check-mint?tokenId=${tokenId}`);
						if (response.data.mintedKey === true) {
							setIsCheckBackendMintEvent(true);
							// await Promise.all([
							// 	refetchTier1(),
							// 	refetchTier2(),
							// 	refetchTier3(),
							// refetchCurrentTier(),
							// 	refetchTier1Minted(),
							// 	refetchTier2Minted(),
							// 	refetchTier3Minted()
							// ]);
							refreshUserData()
							getMintKeys()
							navigate('/my-keys')
							toast({
								title: 'Mint successful!',
								// description: `Transaction hash: ${tx.hash}`,
								status: 'success',
								duration: 9000,
								isClosable: true
							});
						}
					} catch (apiError) {
						console.error('Error checking backend mint data:', apiError);
					}
				};

				if (tokenId) {
					checkBackendMintData(tokenId);
					refreshUserData()
				}
			} catch (parseError) {
				console.error('Error parsing log data:', parseError);
				toast({
					title: 'Mint failed!',
					description: `Error: ${parseError}`,
					status: 'error',
					duration: 9000,
					isClosable: true
				});
			}
		}
	}, [isConfirming, isConfirmed, data, isSuccess]);

	return (
		<Button
			w="80%"
			variant={variant}
			colorScheme={colorScheme}
			isDisabled={isDisabled}
			isLoading={(transactionStatus === 'pending' && !isSuccess && isCurrent) || (transactionStatus === 'success' && !isCheckBackendMintEvent && isCurrent)}
			onClick={handleMint}
		>
			{text}
		</Button>
	);
};

export default MintButton;
